import {Component, Input, OnInit} from '@angular/core';
import {GrowlType, RegExpEmailWithAlias, Validation} from "@app/shared";
import {AchDataService} from "@app/shared/ach/ach-data.service";
import {DwollaCustomer} from "@app/shared/classes/ach-customer";
import {plainToClass} from "class-transformer";
import {GrowlService} from "@app/core";

@Component({
  selector: 'app-ach-update-customer',
  templateUrl: './ach-update-customer.component.html',
  styleUrls: ['./ach-update-customer.component.css']
})
export class AchUpdateCustomerComponent implements OnInit {

  @Input() achCustomerId: string;

  RegExpEmailWithAlias = RegExpEmailWithAlias;

  // standard format and validation
  Validation: typeof Validation = Validation;

  dwollaCustomer: DwollaCustomer;
  displayEditDialog: boolean = false;

  constructor(private achDataService: AchDataService, private growl: GrowlService,) { }

  ngOnInit(): void {

  }

  getCustomerFromDwolla() {
    this.achDataService.getCustomerFromDwolla(this.achCustomerId).subscribe( res => {
      this.dwollaCustomer = plainToClass(DwollaCustomer, res);
    });
  }

  onClickEditCustomer() {
    this.getCustomerFromDwolla();
    this.displayEditDialog = true;
  }

  onClickCancel() {
    this.displayEditDialog = false;
  }

  onClickUpdate(customerId: string) {
    this.achDataService.updateCustomerInDwolla(customerId, this.dwollaCustomer).subscribe(res => {
      this.getCustomerFromDwolla();
      this.growl.add(GrowlType.Success, "Customer Information updated in Dwolla Successfully");
    });
  }



}
